/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { invitationDataRoleSchema } from './InvitationDataRoleSchema'
import { invitationDataStatusSchema } from './InvitationDataStatusSchema'

export const invitationDataSchema = z.object({
	invitationId: z.string(),
	email: z.string(),
	invitedByName: z.string().nullable(),
	invitedById: z.string().nullable(),
	status: invitationDataStatusSchema,
	expirationDate: z.string().nullable(),
	role: invitationDataRoleSchema,
	createdAt: z.string().nullable(),
})

export type InvitationDataSchema = z.infer<typeof invitationDataSchema>
